import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorInfo, RenderingState } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const listDepartmentsSlice = createSlice({
  name: 'LIST_DEPARTMENTS',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetToInitials: (state) => {
      state.isLoading = initialState.isLoading;
      state.success = initialState.success;
      state.error = initialState.error;
    },
  },
});

// REDUCER
export default listDepartmentsSlice.reducer;

// ACTIONS
export const {
  loading,
  success,
  failure,
  resetToInitials,
} = listDepartmentsSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.organization.departments.list.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.organization.departments.list.success;
export const selectError = (state: RootState) =>
  state.ui.organization.departments.list.error;
